import { render } from "./BottomBar.vue?vue&type=template&id=1f1ea00a"
const script = {}

import "./BottomBar.vue?vue&type=style&index=0&id=1f1ea00a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__